import { gql } from '@apollo/client'

export const artistResultFragment = gql`
  fragment artistResult on ArtistResult {
    id
    slug
    name
    avatar
  }
`
